import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { LogIn, LogOut, UserRound, Inbox, KeyRound } from "lucide-react";
import { ChangePasswordDialog } from "@/components/ChangePasswordDialog";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { useAuth } from "@/context/Auth";

export const AccountMenu = () => {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const [pwOpen, setPwOpen] = useState(false);
  if (user === null) return null;
  if (!user) {
    return (
      <button data-testid="header-sign-in-button" onClick={() => nav("/account")} className="btn-primary h-9 px-4 rounded-full text-sm font-semibold flex items-center gap-1.5">
        <LogIn size={14} /> <span className="hidden sm:inline">Sign in</span>
      </button>
    );
  }
  return (
    <>
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button data-testid="header-account-menu" className="btn-ghost h-9 px-3 rounded-full text-sm flex items-center gap-1.5">
          <UserRound size={14} /> <span className="hidden sm:inline max-w-[140px] truncate">{user.name || user.email}</span>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" style={{ background: "var(--surface)" }}>
        <DropdownMenuLabel className="text-xs font-normal" data-testid="header-account-email">{user.email}</DropdownMenuLabel>
        <DropdownMenuSeparator />
        {user.role === "admin" && (
          <DropdownMenuItem data-testid="header-admin-feedback-link" onClick={() => nav("/admin")}><Inbox size={14} className="mr-2" /> View feedback</DropdownMenuItem>
        )}
        <DropdownMenuItem data-testid="header-change-password-button" onClick={() => setPwOpen(true)}><KeyRound size={14} className="mr-2" /> Change password</DropdownMenuItem>
        <DropdownMenuItem data-testid="header-logout-button" onClick={async () => { await logout(); nav("/"); }}><LogOut size={14} className="mr-2" /> Sign out</DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
    <ChangePasswordDialog open={pwOpen} onOpenChange={setPwOpen} />
    </>
  );
};
